import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { ServiceFrequencyTypeDto, ServiceTypeDto } from "../../interfaces/serviceDefinition/service-definition";
import { apiGet, apiPost } from "../../utilities/api-client/apiRequest";




export async function GetAllServiceTypesAsync(
    authToken: string,
): Promise<ApiResponse<ServiceTypeDto[]>> {
    const apiUrl: string = `/ServiceType/GetAllServiceTypes`;

    var res = apiGet<ApiResponse<ServiceTypeDto[]>>(
        apiUrl, authToken)

    return res;
}
